import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { withTranslation } from "react-i18next";
import FormReportConf from "./FormReportConf";
import PDFViewer from "components/Common/PDFViewer/PDFViewer";
import { useSelector } from "react-redux";
const ReportProperties = props => {

  document.title = "Reporte de bienes | Municipio Transparente";

  const [discontinuedModalShow, setDiscontinuedModalShow] = useState(false);

  const handleDiscontinuedModal = () => {
    setDiscontinuedModalShow(!discontinuedModalShow);
  };

  const { discontinued } = useSelector(state => ({
    discontinued: state.ReportsReducer.discontinued,
  }));

  useEffect(() => {
    if (discontinued) {
      setDiscontinuedModalShow(true);
    } else {
      setDiscontinuedModalShow(false);
    }
  }, [discontinued]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Reportes")}
            breadcrumbItem={props.t("Reporte de bienes")}
          />
          <Row>
            <Col xl={12}>
              <Card>  
                <CardBody>
                  <Row>
                    <Col xs="12">
                      <FormReportConf/>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <PDFViewer docData={discontinued} isOpen={discontinuedModalShow} toggle={handleDiscontinuedModal} />
      </div>
    </React.Fragment>
  );
};


export default withTranslation()(ReportProperties);
